import ToastTemplateSubmissionMoved from './SubmissionMoved'
import ToastTemplateTicked from './Ticked'
import ToastTemplateWarning from './Warning'

export { ToastTemplateTicked, ToastTemplateSubmissionMoved, ToastTemplateWarning }
